import React from 'react';
import './Hero.css';

const Hero = () => {
  const navigateToProcess = () => {
    // Navigate to process page using history API
    window.history.pushState({}, '', '/process');
    window.dispatchEvent(new PopStateEvent('popstate'));
    // Ensure page scrolls to top
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  };

  const scrollToSchedule = () => {
    const element = document.getElementById('schedule');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToSearch = () => {
    const element = document.getElementById('appointment-search');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="hero hero-dynamic">
      {/* Welcome Header */}
      <div className="welcome-header">
        <h1 className="welcome-title">ברוכים הבאים לרשיון הנהיגה שלכם</h1>
      </div>
      
      <div className="container">
        <div className="hero-layout">
          {/* Center Welcome Content */}
          <div className="hero-center">
            {/* First Image */}
            <div className="hero-first-image progressive-element stagger-1">
              <img 
                src="/first.jpg" 
                alt="First Image" 
                className="first-image"
              />
            </div>
            
            <h2 className="hero-title">
              רן לוי
            </h2>
            <h3 className="hero-subtitle">
              מורה נהיגה בראש העין, פתח תקווה, קרית אונו והסביבה
            </h3>
            
            <div className="hero-buttons-container">
              <button className="btn btn-main" onClick={scrollToSchedule}>
                קבע שיעור
              </button>
              <div className="hero-buttons-row">
                <button className="btn btn-secondary" onClick={navigateToProcess}>
                  מסמכים ותשלומים
                </button>
                <button className="btn btn-secondary" onClick={scrollToSearch}>
                  השיעורים שלי
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
